module.exports = __webpack_public_path__ + "media/apareix pregunta.4bde9b1b.mp3";